import Vue from 'vue'
import { Button,Progress,Switch} from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css';

Vue.use(Button)
Vue.use(Switch)
Vue.use(Progress)
